import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { ClipboardCheck, ListChecks, BarChart3, ShieldCheck, ArrowRight } from "lucide-react";

const GRUPOS = [
  {
    titulo: "Resultados das avaliações",
    itens: [
      { to: "/avaliacoes", label: "Avaliações práticas", desc: "Fichas práticas por aluno, turma e oficina", icon: ClipboardCheck, color: "text-emerald-400" },
      { to: "/formativa", label: "Avaliações formativas", desc: "Avaliações formativas (0–10)", icon: ListChecks, color: "text-sky-400" },
      { to: "/turmas", label: "Consolidados de turma/oficina", desc: "Selecione a turma e a oficina para ver o consolidado", icon: BarChart3, color: "text-purple-400" },
    ],
  },
  {
    titulo: "Indicadores e relatórios",
    itens: [
      { to: "/capacitados", label: "Capacitados GNA", desc: "Consolidado de capacitados e relação nominal", icon: ShieldCheck, color: "text-amber-400" },
      { to: "/relatorios", label: "Relatórios de instrutores", desc: "Desempenho e produtividade dos instrutores", icon: BarChart3, color: "text-teal-400" },
    ],
  },
];

export default function Resultados() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  return (
    <div data-testid="resultados-page">
      <PageHeader title="Resultados" subtitle="Resultados das avaliações, indicadores e relatórios" />
      <div className="space-y-8">
        {GRUPOS.map((g) => {
          const itens = g.itens.filter((i) => !i.adminOnly || isAdmin);
          if (!itens.length) return null;
          return (
            <div key={g.titulo}>
              <h2 className="font-heading text-lg font-bold uppercase tracking-tight mb-3 text-muted-foreground">{g.titulo}</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {itens.map((i) => (
                  <Card key={i.to} role="button" tabIndex={0} data-testid={`resultado-${i.to.replace(/\//g, "")}`}
                    onClick={() => navigate(i.to)}
                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") navigate(i.to); }}
                    className="p-4 bg-card border-border cursor-pointer hover:border-primary/60 hover:bg-card/70 transition-all active:scale-[0.98] flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-secondary shrink-0"><i.icon className={`h-5 w-5 ${i.color}`} /></div>
                    <div className="min-w-0 flex-1">
                      <div className="font-semibold truncate">{i.label}</div>
                      <div className="text-xs text-muted-foreground leading-snug">{i.desc}</div>
                    </div>
                    <ArrowRight className="h-4 w-4 text-muted-foreground shrink-0" />
                  </Card>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
